import React from "react";
import { InstagramEmbed } from 'react-social-media-embed';
import BottomToTop from "./BottomToTop";
import "./Work.css";

function Work() {

  return (
    <>
    <div>

      <BottomToTop/>

      <div className="container text-center d-flex justify-content-center align-items-center">
        <div className="container mainHeading">
          <h1 style={{fontSize: "3rem", color: "#000000"}}>Work</h1>
        </div>
      </div>

      <div className="workContentDiv">
        <div className="workContent1">
          <img src="workImage.PNG" alt="workImage" className="workContent1Img"></img>
        </div>

        <div className="workContent2">
          <div className="workContent2Div">
            <p className="workContent2Intro" style={{fontSize: "1.15rem", color: "#000000", fontWeight: "400"}}>In 2024 alone, HyperContent has delivered <span style={{fontSize: "1.15rem", color: "#000000", fontWeight: "600"}}>100M+ aggregate reach </span>for our clients, leveraging our unmatched expertise in social media. Our team has grown pages from scratch to <span style={{fontSize: "1.15rem", color: "#000000", fontWeight: "600"}}>700K+ followers in 2024</span>, proving that we understand the algorithms, trends, and strategies better than anyone. We have not only mastered viral growth techniques but also specialise in niche-oriented branding strategies that drive engagement and conversions. Beyond organic success, our precision-driven Meta and Google Ads campaigns have generated <span style={{fontSize: "1.15rem", color: "#000000", fontWeight: "600"}}>1000+ of high-quality leads</span>, making us the go-to agency for brands looking to dominate the digital space.<br/>Check out some of our top-performing work from 2023-2024:</p>
          </div>
        </div>
      </div>



      <div className="text-start">
        <div className="categoryHeading">
          <h2 style={{fontSize: "2rem", color: "#000000"}}>Viral Posts</h2>
        </div>
      </div>

      <div style={{display: "flex", justifyContent:"center", alignItems:"center"}}>
        <div className="row py-2" style={{width:"100%", display:"flex", flexWrap:"wrap"}}>

          <div className="instagramLink col-xs-12 col-sm-6 col-md-6 col-lg-4">
            <div className="instagramLinkContainerDiv">
              <InstagramEmbed className="instagramLinkContainer" url="https://www.instagram.com/reel/DFre-pMz7Ni/?igsh=MWdjY2VrNmNreGMxMQ=="/>
            </div>
          </div>

          <div className="instagramLink col-xs-12 col-sm-6 col-md-6 col-lg-4">
            <div className="instagramLinkContainerDiv">
              <InstagramEmbed className="instagramLinkContainer" url="https://www.instagram.com/reel/DEXX8GZt8wd/?igsh=cm5meDc2djBrMjI2"/>
            </div>
          </div>

          <div className="instagramLink col-xs-12 col-sm-6 col-md-6 col-lg-4">
            <div className="instagramLinkContainerDiv">
              <InstagramEmbed className="instagramLinkContainer" url="https://www.instagram.com/reel/DEzskMHPrX_/?igsh=bDh2aGdpZGV6b3lp"/>
            </div>
          </div>

        </div>
      </div>



      <div className="text-start">
        <div className="categoryHeading" >
          <h2 style={{fontSize: "2rem", color: "#000000"}}>Editing Work</h2>
        </div>
      </div>

      <div style={{display: "flex", justifyContent:"center", alignItems:"center"}}>
        <div className="row py-2" style={{width:"100%", display:"flex", flexWrap:"wrap"}}>

          <div className="instagramLink col-xs-12 col-sm-6 col-md-6 col-lg-4">
            <div className="instagramLinkContainerDiv">
              <InstagramEmbed className="instagramLinkContainer" url="https://www.instagram.com/reel/DGLS-LDzSWc/?igsh=Yzl6aWdkeWdiM3Yx"/>
            </div>
          </div>

          <div className="instagramLink col-xs-12 col-sm-6 col-md-6 col-lg-4">
            <div className="instagramLinkContainerDiv">
              <InstagramEmbed className="instagramLinkContainer" url="https://www.instagram.com/reel/DGNAnbDqusS/?igsh=bG1tM3Nza3h0dnZs"/>
            </div>
          </div>

          <div className="instagramLink col-xs-12 col-sm-6 col-md-6 col-lg-4">
            <div className="instagramLinkContainerDiv">
              <InstagramEmbed className="instagramLinkContainer" url="https://www.instagram.com/reel/DD41ardhcrh/?igsh=Z2Z4bHNwdmw2cWw2"/>
            </div>
          </div>

        </div>
      </div>




      <div className="text-start">
        <div className="categoryHeading">
          <h2 style={{fontSize: "2rem", color: "#000000"}}>Podcast Work</h2>
        </div>
      </div>

      <div style={{display: "flex", justifyContent:"center", alignItems:"center"}}>
        <div className="row py-2" style={{width:"100%", display:"flex", flexWrap:"wrap"}}>

          <div className="youtubeLink col-xs-12 col-sm-6 col-md-6 col-lg-4">
            <div className="youtubeLinkContainerDiv">
              <iframe className="youtubeLinkContainer" src="https://www.youtube.com/embed/IBCcXMecG_E?si=fqanxmILm0C0yAh6" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>
            </div>
          </div>

          <div className="youtubeLink col-xs-12 col-sm-6 col-md-6 col-lg-4">
            <div className="youtubeLinkContainerDiv">
              <iframe className="youtubeLinkContainer" src="https://www.youtube.com/embed/mYYk8E9H6DI?si=hTx8OsNOkMp5UIiW" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>
            </div>        
          </div>

          <div className="youtubeLink col-xs-12 col-sm-6 col-md-6 col-lg-4">
            <div className="youtubeLinkContainerDiv">
              <iframe className="youtubeLinkContainer" src="https://www.youtube.com/embed/xOgGg-8Ky8E?si=iyUF-KNpJyi8rq8G" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>
            </div>       
          </div>

        </div>
      </div>



      <div className="text-start">
        <div className="categoryHeading" >
          <h2 style={{fontSize: "2rem", color: "#000000"}}>Human Content</h2>
        </div>
      </div>

      <div style={{display: "flex", justifyContent:"center", alignItems:"center"}}>
        <div className="row py-2" style={{width:"100%", display:"flex", flexWrap:"wrap"}}>

          <div className="instagramLink col-xs-12 col-sm-6 col-md-6 col-lg-4">
            <div className="instagramLinkContainerDiv">
              <InstagramEmbed className="instagramLinkContainer" url="https://www.instagram.com/reel/DEzpaTWyr3K/?igsh=MW16ZnoxdXA3a2V5dQ=="/>
            </div>
          </div>

          <div className="instagramLink col-xs-12 col-sm-6 col-md-6 col-lg-4">
            <div className="instagramLinkContainerDiv">
              <InstagramEmbed className="instagramLinkContainer" url="https://www.instagram.com/reel/DCVyG7nhtnK/?igsh=MWoxNnBreWQxdzE2bA=="/>
            </div>
          </div>

          <div className="instagramLink col-xs-12 col-sm-6 col-md-6 col-lg-4">
            <div className="instagramLinkContainerDiv">
              <InstagramEmbed className="instagramLinkContainer" url="https://www.instagram.com/reel/DD2VuZhBrcN/?igsh=MTdmcHUzMTRoYjZiNA=="/>
            </div>
          </div>

        </div>
      </div>



      <div className="text-start">
        <div className="categoryHeading" >
          <h2 style={{fontSize: "2rem", color: "#000000"}}>A.I Content</h2>
        </div>
      </div>

      <div style={{display: "flex", justifyContent:"center", alignItems:"center"}}>
        <div className="row py-2" style={{width:"100%", display:"flex", flexWrap:"wrap"}}>

          <div className="instagramLink col-xs-12 col-sm-6 col-md-6 col-lg-4">
            <div className="instagramLinkContainerDiv">
              <InstagramEmbed className="instagramLinkContainer" url="https://www.instagram.com/reel/DFiBDsGvitb/?igsh=MTNzbjN1d2pqaXNrNg=="/>
            </div>
          </div>

          <div className="instagramLink col-xs-12 col-sm-6 col-md-6 col-lg-4">
            <div className="instagramLinkContainerDiv">
              <InstagramEmbed className="instagramLinkContainer" url="https://www.instagram.com/reel/DFskP50Bfjh/?igsh=MWtxbWo0Z3AwNjg0Yg=="/>
            </div>
          </div>

          <div className="instagramLink col-xs-12 col-sm-6 col-md-6 col-lg-4">
            <div className="instagramLinkContainerDiv">
              <InstagramEmbed className="instagramLinkContainer" url="https://www.instagram.com/reel/DFonocmTFu2/?igsh=MWJrYTZuZW9rcjZwbA=="/>
            </div>
          </div>

        </div>
      </div>


      
    </div>
    </>
  );
}

export default Work;